import { Stack } from "@mui/material";
import React from "react";

export default function ProfileCard({ title, children, ...props }) {
  return (
    <Stack direction="column" spacing={2} width="calc(100% - 40px)" {...props} sx={{ backgroundColor: '#fff', padding: '20px', borderRadius: '20px'}}>
      {title && <h4>{title}</h4>}
      <Stack direction="column" spacing={2} width="100%">
        {children}
      </Stack>
    </Stack>
  );
}